import { motion } from "framer-motion";

import AnimatedCounter from "../../AnimatedCounter/AnimatedCounter";
import Card from "../../Card/Card";
import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { getIcon } from "../../../Utils/iconMap";
import { dataSolutionsCards, dataSolutionsStats } from "../../../Data/dataSolutionsData";

import "../../../Style/home/dataSolutions.css";

function DataSolutions() {
  return (
    <section id="solutions" className="section section--tint section--grid data-solutions">
      <span className="blob blob--blue data-solutions__blob data-solutions__blob--one" />
      <span className="blob blob--magenta data-solutions__blob data-solutions__blob--two" />

      <Container>
        <SectionTitle
          eyebrow="Real-Time Data"
          title="A smarter way to find"
          highlight="your market."
          description="Live signals instead of static lists — so your team always knows who to talk to next, and why."
        />

        <motion.div
          className="card-grid card-grid--3"
          variants={staggerContainer(0.08)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {dataSolutionsCards.map((card) => (
            <Card key={card.id} interactive gradientBorder variants={fadeUp()} className="data-solutions__card">
              <IconBox icon={getIcon(card.icon)} />
              <h3 className="card__title mt-5">{card.title}</h3>
              <p className="card__text">{card.text}</p>
            </Card>
          ))}
        </motion.div>

        <motion.div
  className="data-solutions__stats"
  variants={staggerContainer(0.1)}
  initial="hidden"
  whileInView="show"
  viewport={viewportOnce}
>
  {dataSolutionsStats.map((stat) => (
    <motion.div key={stat.id} variants={fadeUp()} className="data-solutions__stat">
      <div className="data-solutions__stat-value">
        <AnimatedCounter value={stat.value} suffix={stat.suffix} className="text-gradient" />
      </div>
      <p className="data-solutions__stat-label">{stat.label}</p>
    </motion.div>
  ))}
</motion.div>
      </Container>
    </section>
  );
}

export default DataSolutions;